// extracted by mini-css-extract-plugin
export default {"form-add-user":"BusinessAddStaff_form-add-user__QSsrK"};